import { render, staticRenderFns } from "./Pickups.vue?vue&type=template&id=f0b3ef70&"
import script from "./Pickups.vue?vue&type=script&lang=js&"
export * from "./Pickups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports